import {BaseDomainService} from "../../../infrastructure/domain-services/base-domain-service";
import {BaseManagedService} from "../../../infrastructure/domain-services/base-managed-service";
import {DomainRequestManager} from "../../../core/managers/domain-request-manager";
import {NewsFactory} from "./news.factory";
import {NewsRepository} from "./news.repository";

export class NewsDomainService extends BaseDomainService {
  static injectables = [...BaseManagedService.injectables, NewsRepository, NewsFactory, DomainRequestManager];
}
